<app-departments-list-component />
